import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { en_US, NzI18nService, zh_CN, zh_TW } from 'ng-zorro-antd/i18n';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { WaittingSignCountService } from 'src/app/shared/service/common/waitting-sign-count.service';
import { AuthService } from '../../auth/services/auth.service';
import menu from './constants/menu';
import { MenuModel } from './models/menu-father';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  language: string = localStorage.getItem('language');
  // 面包屑的i18N
  translateFn = (key: string) => {
    let translateValue = '';
    if (!!key) {
      const value = 'Common.' + key;
      translateValue = this.translateService.instant(value);
    }
    return translateValue;
  };


  subscription: Subscription;
  //登錄用戶名
  username: string | null = "";
  //系统时间
  date = "";
  dateTimer = null;//定时器
  selectLanguage: string = '';
  languageItems = [];

  // 侧边导航栏默认是展开的
  isCollapsed = false;
  //菜单栏
  menus: MenuModel[] = menu;

  // 徽标数,显示待签核数量,为0时不显示.

  // 需求单位待签核数量
  step1WaittingCount: number;
  step2WaittingCount: number;

  // 厂务待签核数量
  step3WaittingCount: number;
  step7WaittingCount: number;
  step8BidWaittingCount: number;
  step8BudgetWaittingCount: number;

  // 预约厂商待签核数量
  step4WaittingCount: number;
  step6WaittingCount: number;

  // 厂商标单制定待制定数量
  step5WaittingCount: number;

  // (专案工程)总数
  step9InquiryWaittingCount: number;
  // 询价(一般工程)总数
  step10InquiryWaittingCount: number;

  // 概算签核--一般工程的待签总数
  step9BudgetWaittingCount: number;
  // 概算签核--一般工程的专案总数
  step10BudgetWaittingCount: number;

  // 待开PO
  step11WaittingCount: number;
  step12WaittingCount: number;
  step13WaittingCount: number;
  step14WaittingCount: number;
  step15WaittingCount: number;

  constructor(
    private authService: AuthService,
    private waittingSignCountService: WaittingSignCountService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private i18n: NzI18nService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  async ngOnInit(): Promise<void> {


    // 用户可选择的语言
    const config = this.commonService.configJson;
    this.languageItems = config.language;

    // 获取历史选择语言
    if (!!this.language) {
      this.initLanguage(this.language);
      moment.locale(this.language);

    }
    //如果没有历史选择语言,则默认显示浏览器语言
    else {
      // navigator.language仅可代表浏览器语言，并不能代表当前系统语言
      // const browserLannguage = navigator.language.replace('-', '_');
      // const lang = browserLannguage.includes('zh') ? browserLannguage === 'zh_CN' ? browserLannguage : 'zh_TW' : "en_US";
      const lang = 'zh_CN';
      moment.locale(lang);
      this.initLanguage(lang);
    }
    this.dateTimer = setInterval(() => {
      this.date = moment().format('llll');
    }, 1000);

    // 登陆用户的工号
    this.username = localStorage.getItem("userName");


    // 获取当前用户所拥有权限访问的菜单栏
    this.menus = JSON.parse(localStorage.getItem("menus"));

    // 查询单位签核的待签数量
    this.step1WaittingCount = await this.waittingSignCountService.getStepWaittingCount(1);
    this.step2WaittingCount = await this.waittingSignCountService.getStepWaittingCount(2);

    // 查询厂务签核的待签总数
    this.step3WaittingCount = await this.waittingSignCountService.getStepWaittingCount(3);
    this.step7WaittingCount = await this.waittingSignCountService.getStepWaittingCount(7);
    this.step8BidWaittingCount = await this.waittingSignCountService.getStepWaittingCount(8, 1);
    this.step8BudgetWaittingCount = await this.waittingSignCountService.getStepWaittingCount(8, 0);

    // 查询预约厂商的待预约总数
    this.step4WaittingCount = await this.waittingSignCountService.getStepWaittingCount(4);
    // 查询厂务概算制定的待制定总数
    this.step6WaittingCount = await this.waittingSignCountService.getStepWaittingCount(6);

    // 查询厂商标单制定的待制定总数
    this.step5WaittingCount = await this.waittingSignCountService.getStepWaittingCount(5);

    // 查询询价(专案工程)的待签核总数
    this.step9InquiryWaittingCount = await this.waittingSignCountService.getStepWaittingCount(9, 1);
    // 查询询价(一般工程)的待签核总数
    this.step10InquiryWaittingCount = await this.waittingSignCountService.getStepWaittingCount(10, 0);

    // 查询概算签核--一般工程的待签总数
    this.step9BudgetWaittingCount = await this.waittingSignCountService.getStepWaittingCount(9, 0);
    // 查询概算签核--专案工程的待签总数
    this.step10BudgetWaittingCount = await this.waittingSignCountService.getStepWaittingCount(10, 1);

    // 待开PO
    this.step11WaittingCount = await this.waittingSignCountService.getStepWaittingCount(11);
    this.step12WaittingCount = await this.waittingSignCountService.getStepWaittingCount(12);
    this.step13WaittingCount = await this.waittingSignCountService.getStepWaittingCount(13);
    this.step14WaittingCount = await this.waittingSignCountService.getStepWaittingCount(14);
    this.step15WaittingCount = await this.waittingSignCountService.getStepWaittingCount(15);
  }

  //登出
  logout() {
    this.authService.logout();
    clearInterval(this.dateTimer);
  }

  commonLanguage(languevalue: string) {
    this.language = languevalue;
    localStorage.setItem('language', languevalue);
    this.translateService.use(this.language);//切换语言
    moment.locale(this.language);
    this.date = moment(new Date()).format('llll');
    // Zorro 的i18N
    if (this.language === 'en_US') {
      this.i18n.setLocale(en_US);//切换Zorro组件内置的语言
    }
    else {
      this.i18n.setLocale(this.language === 'zh_CN' ? zh_CN : zh_TW);//切换Zorro组件内置的语言
    }

    this.getLangLabel();
  }

  initLanguage(languevalue: string) {
    this.commonLanguage(languevalue);
  }
  // 切换语言
  switLanguage(languevalue: any) {
    this.commonLanguage(languevalue);
    this.document.location.reload();//重新加载组件
  }

  getLangLabel() {
    let language = localStorage.getItem('language');
    let lang = this.languageItems.find(
      (item) => item.value == language
    );
    if (!!lang) {
      this.selectLanguage = lang.label;
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
